import { Action } from '@ngrx/store';
import { Comment } from '@app/models/comment';

export enum CommentActionTypes {
  Load = '[API] Load comments',
  LoadSuccess = '[API] Load comments success',
  LoadFail = '[API] Load comments fail',
  LoadByProduct = '[API] Load comments by product',
  LoadByProductSuccess = '[API] Load comments by product success',
  LoadByProductFail = '[API] Load comments by product fail',
  Create = '[API] Create comment',
  CreateSuccess = '[API] Create comment success',
  CreateFail = '[API] Create comment fail',
  AddOne = '[Comment] Add one',
  AddMany = '[Comment] Add may',
  AddAll = '[Comment] Add all'
}

export class Load implements Action {
  readonly type = CommentActionTypes.Load;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = CommentActionTypes.LoadSuccess;
  constructor(public comments: Comment[]) {}
}

export class LoadFail implements Action {
  readonly type = CommentActionTypes.LoadFail;
  constructor(public error: any) {}
}

export class LoadByProduct implements Action {
  readonly type = CommentActionTypes.LoadByProduct;
  constructor(public productId: number) {}
}

export class LoadByProductSuccess implements Action {
  readonly type = CommentActionTypes.LoadByProductSuccess;
  constructor(public comments: Comment[]) {}
}

export class LoadByProductFail implements Action {
  readonly type = CommentActionTypes.LoadByProductFail;
  constructor(public error: any) {}
}

export class Create implements Action {
  readonly type = CommentActionTypes.Create;
  constructor(public data: any) {}
}

export class CreateSuccess implements Action {
  readonly type = CommentActionTypes.CreateSuccess;
  constructor(public comment: Comment) {}
}

export class CreateFail implements Action {
  readonly type = CommentActionTypes.CreateFail;
  constructor(public error: any) {}
}

export class AddOne implements Action {
  readonly type = CommentActionTypes.AddOne;
  constructor(public comment: Comment) {}
}

export class AddMany implements Action {
  readonly type = CommentActionTypes.AddMany;
  constructor(public comments: Comment[]) {}
}

export class AddAll implements Action {
  readonly type = CommentActionTypes.AddAll;
  constructor(public comments: Comment[]) {}
}

export type CommentActionsUnion =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadByProduct
  | LoadByProductSuccess
  | LoadByProductFail
  | Create
  | CreateSuccess
  | CreateFail
  | AddOne
  | AddMany
  | AddAll;
